<template>
  <div>
    <v-select :items="items" v-bind:value="value" v-on:change="$emit('input', $event)" hide-details single-line dense class="pt-0"></v-select>
  </div>
</template>

<script>
export default {
  name: 'AgencesList',
  props: {
    value: String
  },
  data() {
    return {
      items: ['Toutes', 'Gironde', 'Ile de France', 'Côte Basque', 'Rhône Alpes', 'Caractère']
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
